import { Route, Routes } from "react-router-dom";

import { SIntegradaContextProvider } from "@/contexts/SIntegradaContext";
import { PermissionEnum } from "@/utils/enums/PermissionEnum";

import { Restrict } from "@/components/Restrict";
import { ReceptionDashboard } from "@/pages/sintegrada/ReceptionDashboard";
import { RiskClassificationDashboard } from "@/pages/sintegrada/RiskClassificationDashboard";
import { MedicalOfficeDashboard } from "@/pages/sintegrada/MedicalOfficeDashboard";
import { SpecialtyOfficeDashboard } from "@/pages/sintegrada/SpecialtyOfficeDashboard";
import { HospitalizationDashboard } from "@/pages/sintegrada/HospitalizationDashboard";
import { ExamDashboard } from "@/pages/sintegrada/ExamDashboard";
import { GeneralPatients } from "@/pages/sintegrada/GeneralReports/GeneralPatients";
import { GeneralDeaths } from "@/pages/sintegrada/GeneralReports/GeneralDeaths";
import { GeneralProcedures } from "@/pages/sintegrada/GeneralReports/GeneralProcedures";
import { GeneralEvasions } from "@/pages/sintegrada/GeneralReports/GeneralEvasions";
import { GeneralAttendances } from "@/pages/sintegrada/GeneralReports/GeneralAttendances";
import { GrievanceNotificationReport } from "@/pages/sintegrada/GrievanceNotificationReport";
import { OccupationReport } from "@/pages/sintegrada/OccupationReport";
import { MedicalAttendanceReport } from "@/pages/sintegrada/MedicalAttendanceReport";
import { DiagnosticHypothesisReport } from "@/pages/sintegrada/DiagnosticHypothesisReport";
import { DischargeReport } from "@/pages/sintegrada/DischargeReport";

const CitySIntegradaRoutes = () => {
	return (
		<SIntegradaContextProvider>
			<Routes>
				<Route
					path="/sintegrada/relatorios/setor/recepcao"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<ReceptionDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/setor/classificacao-risco"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<RiskClassificationDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/setor/consultorio-medico"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<MedicalOfficeDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/setor/consultorio-especialidade"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<SpecialtyOfficeDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/setor/hospitalizacao"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<HospitalizationDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/consultorio"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<MedicalAttendanceReport />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/alta"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<DischargeReport/>
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/ocupacao"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<OccupationReport />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/hipotese-diagnostica"
					element={
						<Restrict permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}>
							<DiagnosticHypothesisReport />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/procedimento"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<ExamDashboard />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/lista/atendimentos"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<GeneralAttendances />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/lista/pacientes"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<GeneralPatients />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/lista/evasoes"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<GeneralEvasions />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/lista/procedimentos"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<GeneralProcedures />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/lista/obitos"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<GeneralDeaths />
						</Restrict>
					}
				/>
				<Route
					path="/sintegrada/relatorios/lista/notificacoes-de-agravos"
					element={
						<Restrict
							permissions={[PermissionEnum.SINTEGRADA_VIEW_REPORTS]}
							redirectIfNotAuthorized
						>
							<GrievanceNotificationReport />
						</Restrict>
					}
				/>
			</Routes>
		</SIntegradaContextProvider>
	);
};

export { CitySIntegradaRoutes };
